import React from 'react';
import createSvgIcon from '../../../general/icons/createSvgIcon';

const Icon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.9183 11.7515L14.6666 7.02159V24.7497H18.3333V7.02159L23.0816 11.7515L25.6666 9.16656L16.5 0L7.3333 9.16656L9.9183 11.7515ZM29.3333 29.3331V16.4999H33V29.3331C33 31.3498 31.35 32.9997 29.3333 32.9997H3.66667C1.65 32.9997 0 31.3498 0 29.3331V16.4999H3.66667V29.3331H29.3333Z"
    fill="var(--yellow-yellow-primary)"
  />,
  'Upload',
);

export const Upload = (props: any) => <Icon viewBox="0 0 33 33" {...props} />;
